import { render, staticRenderFns } from "./TabContentThumbnail.vue?vue&type=template&id=79c4dcbd&scoped=true&"
import script from "./TabContentThumbnail.vue?vue&type=script&lang=js&"
export * from "./TabContentThumbnail.vue?vue&type=script&lang=js&"
import style0 from "@/styles/components/TabContentThumbnail/TabContentThumbnail.less?vue&type=style&index=0&id=79c4dcbd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c4dcbd",
  null
  
)

export default component.exports